import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './MarketingNewsletter.scss';

const isValidEmail = (value = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());

// Bloque reutilizable para capturar emails desde cualquier diseño de tienda.
// La persistencia queda en el callback para que cada home conserve su flujo actual.
const MarketingNewsletter = ({
  email,
  onEmailChange,
  onSubmit,
  loading,
  clientName,
  variant,
  className,
}) => {
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const cleanEmail = String(email || '').trim();

    if (!isValidEmail(cleanEmail)) {
      setMessage('Ingresá un email válido para recibir novedades.');
      setMessageType('error');
      return;
    }

    const result = onSubmit(cleanEmail);
    if (result === false) return;

    setMessage('Listo. Te vamos a avisar cuando haya lanzamientos, promos y novedades.');
    setMessageType('success');
  };

  return (
    <section
      className={`marketing-newsletter marketing-newsletter--${variant} ${className}`.trim()}
      aria-labelledby="marketing-newsletter-title"
    >
      <div className="marketing-newsletter__box">
        <div className="marketing-newsletter__copy">
          <span className="marketing-newsletter__eyebrow">Novedades de {clientName || 'la tienda'}</span>
          <h2 id="marketing-newsletter-title">Suscribite y recibí novedades</h2>
          <p>Promos, lanzamientos, descuentos y colecciones exclusivas antes que nadie.</p>
          <div className="marketing-newsletter__chips" aria-label="Beneficios de suscribirse">
            <span>Ofertas</span>
            <span>Nuevos ingresos</span>
            <span>Contenido de la marca</span>
          </div>
        </div>

        <form className="marketing-newsletter__form" onSubmit={handleSubmit} noValidate>
          <label className="sr-only" htmlFor="marketing-newsletter-email">Email</label>
          <input
            id="marketing-newsletter-email"
            type="email"
            value={email}
            onChange={(event) => {
              onEmailChange(event.target.value);
              if (message) {
                setMessage('');
                setMessageType('');
              }
            }}
            placeholder="Tu email aquí..."
            autoComplete="email"
            aria-describedby={message ? 'marketing-newsletter-message' : undefined}
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
          {message && (
            <p
              id="marketing-newsletter-message"
              className={`marketing-newsletter__message marketing-newsletter__message--${messageType}`}
              role={messageType === 'error' ? 'alert' : 'status'}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

MarketingNewsletter.defaultProps = {
  email: '',
  loading: false,
  clientName: '',
  variant: 'default',
  className: '',
};

MarketingNewsletter.propTypes = {
  email: PropTypes.string,
  onEmailChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  clientName: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default MarketingNewsletter;
